import React, { useState, useEffect } from "react";
import "../App.css";
import logo from "../assets/UpdatedMainLogo.png";
import { useNavigate, useLocation, Link } from "react-router-dom";
import getApiBase from "../components/getApiBase";
import { getAuthHeaders } from "../utils/authFetch";
import CloseIcon from '@mui/icons-material/Close';

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation(); // Track route changes
  const [menuOpen, setMenuOpen] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);
  const [profileUrl, setProfileUrl] = useState("/profile");
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    const checkLoginStatus = async () => {
      try {
        // Check authentication via API
        const response = await fetch(`${getApiBase()}/api/auth/me`, {
          credentials: "include",
          headers: getAuthHeaders(),
        });
        
        if (response.ok) {
          const data = await response.json();
          const userData = data.user || data; // Handle nested user object
          const role = userData.role;
          
          setLoggedIn(true);
          
          if (role === "Mechanic" || role === "Owner") {
            setProfileUrl("/mechanic-profile");
          } else {
            setProfileUrl("/profile");
          }
          
          // Check if user is admin - only for Users, not Mechanics
          if (role === "Admin") {
            setIsAdmin(true);
            console.log("Auth check - Legacy Admin Role:", role);
          } else if (role === "Mechanic" || role === "Owner") {
            // Mechanics should never have admin access
            setIsAdmin(false);
            console.log("Auth check - Mechanic role, no admin access");
          } else {
            // Check new admin roles system for Users only
            try {
              const adminResponse = await fetch(`${getApiBase()}/api/admin-management/permissions`, {
                credentials: "include",
                headers: getAuthHeaders(),
              });
              if (adminResponse.ok) {
                const adminData = await adminResponse.json();
                setIsAdmin(adminData.isAdmin === true);
                console.log("Auth check - Admin Role System:", adminData);
              } else {
                setIsAdmin(false);
              }
            } catch (err) {
              console.log("Failed to check admin permissions:", err);
              setIsAdmin(false);
            }
          }
        } else {
          setLoggedIn(false);
          setIsAdmin(false);
        }
      } catch (err) {
        console.error("Auth check failed:", err);
        setLoggedIn(false);
        setIsAdmin(false);
      }
    };

    checkLoginStatus();
  }, [location]); // Re-check authentication on route changes

  const handleLogout = async () => {
    try {
      await fetch(`${getApiBase()}/api/auth/logout`, {
        method: "POST",
        credentials: "include",
        headers: getAuthHeaders(),
      });
      //console.log("✅ Logged out");
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      sessionStorage.removeItem("billing_setup_dismissed");
      sessionStorage.removeItem("billing_setup_return_failed");
      
      // Force immediate header update
      setLoggedIn(false);
      setIsAdmin(false);
      setProfileUrl("/profile");
      
      // Determine the correct base domain for the current environment
      const hostname = window.location.hostname;
      let baseDomain;
      
      if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
        baseDomain = `http://localhost:${window.location.port || 3000}`;
      } else if (hostname.includes('vercel.app')) {
        // Vercel preview deployments - stay on the same preview URL
        baseDomain = `${window.location.protocol}//${hostname}`;
      } else if (hostname.includes('test.autoshops.com')) {
        baseDomain = 'https://test.autoshops.com';
      } else {
        baseDomain = 'https://autoshops.com';
      }
      
      // Redirect to environment-appropriate login page
      window.location.href = `${baseDomain}/login`;
    } catch (err) {
      console.error("❌ Logout failed:", err);
      // Force immediate header update even on error
      setLoggedIn(false);
      setIsAdmin(false);
      setProfileUrl("/profile");
      
      // Determine the correct base domain for the current environment
      const hostname = window.location.hostname;
      let baseDomain;
      
      if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
        baseDomain = `http://localhost:${window.location.port || 3000}`;
      } else if (hostname.includes('vercel.app')) {
        // Vercel preview deployments - stay on the same preview URL
        baseDomain = `${window.location.protocol}//${hostname}`;
      } else if (hostname.includes('test.autoshops.com')) {
        baseDomain = 'https://test.autoshops.com';
      } else {
        baseDomain = 'https://autoshops.com';
      }
      
      // Redirect to environment-appropriate login page even on error
      window.location.href = `${baseDomain}/login`;
    }
  };

  return (
    <header className="site-header">
      <div className="header-container">
        <div className="logo">
          <a href="" onClick={() => navigate("/")}>
            <img src={logo} alt="Autoshops.com Logo"/>
          </a>
        </div>

        {!menuOpen ? (
          <button
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          ☰
        </button>
        ) : (
          <button
          className="hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <CloseIcon sx={{ fontSize: 32, }} />
        </button>
        )}
        

        <nav className={`main-nav ${menuOpen ? "open" : ""}`}>
          <ul>
            <li>
              <Link to="/about" className={location.pathname === "/about" ? "active" : ""}>
                About Us
              </Link>
            </li>
            <li>
              <Link to="/help" className={location.pathname === "/help" ? "active" : ""}>
                Help
              </Link>
            </li>
            <li>
              <Link to="/contact" className={location.pathname === "/contact" ? "active" : ""}>
                Contact
              </Link>
            </li>
            <li>
              <Link to="/google-wrapper" className={location.pathname === "/google-wrapper" ? "active" : ""}>
                Shops Near Me
              </Link>
            </li>
            <li>
              <Link to="/obd" className={location.pathname === "/obd" ? "active" : ""}>
                Diagnostic Code
              </Link>
            </li>
            {loggedIn ? (
              <>
                <li>
                  <Link to={profileUrl} className={location.pathname === profileUrl ? "active" : ""}>
                    Profile
                  </Link>
                </li>
                {isAdmin && (
                  <li>
                    <Link to="/admin" className={location.pathname === "/admin" ? "active" : ""}>
                      Admin Dashboard
                    </Link>
                  </li>
                )}
                <li>
                  <a onClick={handleLogout} style={{ cursor: "pointer" }} className="login-button">Logout</a>
                </li>
              </>
            ) : (
              <li>
                <Link to="/login" className={`login-button ${location.pathname === "/login" ? "active" : ""}`}>
                  Login
                </Link>
              </li>
            )}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
